import { render, staticRenderFns } from "./TechEvalItem.vue?vue&type=template&id=f97e7048&scoped=true&"
import script from "./TechEvalItem.vue?vue&type=script&lang=js&"
export * from "./TechEvalItem.vue?vue&type=script&lang=js&"
import style0 from "./TechEvalItem.vue?vue&type=style&index=0&id=f97e7048&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97e7048",
  null
  
)

export default component.exports